import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a2879aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "business-status-steps" }
const _hoisted_2 = { class: "business-status-popover" }

import { ref, onBeforeMount, computed, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { message } from '@dc-platform/dc-components'
import TabsOperationLog from '@/components/TabsOperationLog/index.vue'
import TabsClueCosFollowUp from '@/components/TabsClueCosFollowUp'
import BusinessForm from './components/BusinessForm.vue'
import { businessStatusEnum } from '@/views/yuntuSales/commonEnum/dataConfig'
import { businessDetails, businessStatusRecord, businessChangeStatus } from '@/api/yuntuSales/chanceManage'
import { listByParamCodes } from '@/api/common'
import type { ParamCodeItem } from '@/typings/common'
import type { LbuBusinessEditParams } from '@/typings/api/chanceManage'
import DetailViewForm from '@/views/yuntuSales/chanceManage/business/components/DetailViewForm.vue'
import { useAreaStore } from '@/stores/area'


const __default__ = { name: 'DcCosLbuBusinessView' }

interface StatusStepItem {
  chanceStatus: number
  updateTime: string
  chanceId?: string
  label?: string
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const router = useRouter()
const route = useRoute()
const permissionFollow = {
  edit: 'lbu_business_follow_edit_btn',
  del: 'lbu_business_follow_del_btn'
}

const queryId = computed(() => route.query.id as string)
const dataForm = ref<LbuBusinessEditParams>({})
const originalStatus = ref<number>()
const waitingChangeStepList = ref<any[]>([])
const areaStore = useAreaStore()
const paramCodeData = ref<{
  lbu_demand_country?: ParamCodeItem[]
  lbu_products?: ParamCodeItem[]
}>({
  lbu_demand_country: [], // 目的地国家
  lbu_products: [] // 出货渠道（云途产品）
})
// 获取业务参数
const getByParamCodes = () => {
  return new Promise((resolve) => {
    listByParamCodes({
      appId: 'cos_lbu',
      paramCodes: ['lbu_demand_country', 'lbu_products']
    }).then((res) => {
      paramCodeData.value = res.data
      resolve(res.data)
    })
  })
}

const stepsList = ref<any>([])
const successStep = {
  // label: '达到承诺业务量(SHIPPING TO PROFILE)',
  label: '06-达到承诺业务量',
  value: 7
}
const failStep = {
  // label: '不能合作(UNABLE TO GAIN)',
  label: '07-不能合作',
  value: 6
}
const futureStep = {
  // label: '未来机会(FUTURE OPPORTUNITIES)',
  label: '08-未来机会',
  value: 8
}
const getStatusSteps = () => {
  businessStatusRecord(queryId.value).then((res) => {
    if (!res.data || !res.data.length) return
    stepsList.value.forEach((item: any, i: number) => {
      const find = res.data.find((ele: StatusStepItem) => ele.chanceStatus === item.value)
      item.updateTime = find ? find.updateTime : undefined
      if (item.value === status.value) {
        stepIndex.value = i
      }
    })
  })
}
const status = ref<number>(1)
const stepIndex = ref<number>(1)
const getDetails = () => {
  return new Promise((resolve) => {
    businessDetails({ id: route.query.id }).then((res) => {
      status.value = res.data.status
      originalStatus.value = res.data.status
      if (!res.data.failedCooperateId) {
        res.data.failedCooperateId = undefined
      }
      if (!res.data.assistDepartment) {
        res.data.assistDepartment = undefined
      }
      dataForm.value = res.data
      formatLbu()
      resolve(res.data)
    })
  })
}
const initFn = async () => {
  await getDetails()
  getStatusSteps()
}
watch(
  () => status.value,
  () => {
    const currentStatus = status.value
    stepsList.value = businessStatusEnum.filter((item) => item.value < 6 || item.value === 9)
    if (currentStatus === 6) {
      stepsList.value.push(failStep)
    } else if (currentStatus === 8) {
      stepsList.value.push(futureStep)
    } else {
      stepsList.value.push(successStep)
    }

    // 编辑的时候，状态只能往下选
    // 未能合作6或者未来机会8 不受控制
    if (currentStatus === 6 || currentStatus === 8) {
      waitingChangeStepList.value = businessStatusEnum.map((item) => ({ ...item, disabled: ![0, 6, 8].includes(item.value) }))
    } else if (currentStatus === 7) {
      // 如果商机状态7达成承诺业务量，则不可变更为其他状态（新版【达到承诺业务量】商机状态可以变更为【不能合作】与【未来机会】）
      waitingChangeStepList.value = businessStatusEnum.map((item) => ({ ...item, disabled: item.value !== 6 && item.value !== 8 }))
    } else if (currentStatus === 9) {
      // 准备发件
      waitingChangeStepList.value = businessStatusEnum.map((item) => ({ ...item, disabled: item.value < 5 || item.value === 5 || item.value === 7 }))
    } else {
      // 其余状态只可以向后变更
      waitingChangeStepList.value = businessStatusEnum.map((item) => ({ ...item, disabled: item.value < currentStatus || item.value === 4 || item.value === 9 || item.value === 5 || item.value === 7 }))
    }
    console.log(waitingChangeStepList.value)
  },
  { immediate: true }
)
onBeforeMount(async () => {
  await getByParamCodes()
  await areaStore.fetchData()
  initFn()
})

// 跳转编辑页面
const handleEdit = () => {
  router.push({ path: '/lbu/business/edit', query: { id: queryId.value } })
}
// 跳转写跟进页面
const handleWriteFollowUp = () => {
  router.push({
    path: '/lbu/followUpRecord/add',
    query: { followRefId: dataForm.value.saleChanceRefId, chanceId: dataForm.value.id, returnPath: route.fullPath }
  })
}

const businessFormRef = ref()
const loading = ref(false)
const statusChange = (e: any) => {
  loading.value = true
  const params = {
    id: route.query.id as string,
    status: e.target.value
  }
  businessChangeStatus(params)
    .then(async () => {
      message.success('状态变更成功')
      initFn()
    })
    .catch(() => {
      status.value = dataForm.value.status || 1
    })
    .finally(() => {
      loading.value = false
    })
}

const activeTabs = ref('info')
const handleTabsChange = (val: any) => {
  console.log(val)
}

// 1. 先将树形结构扁平化，处理为同级
const flatTreeAndSetLevel = (tree: any, level = 1) => {
  const list: any[] = []
  tree.forEach((item: any) => {
    if (level === 1) item.parentId = 0 // 第一级设置父级id为0
    const o = JSON.parse(JSON.stringify(item))
    if (o.children) delete o.children
    o.level = level
    list.push(o)
    if (item.children && item.children.length) {
      list.push(...flatTreeAndSetLevel(item.children, level + 1))
    }
  })
  return list
}
// 2. 遍历上面扁平后的的数据，先根据id找出第一个，然后再根据它的parentId再找，直到找到parentId为0的为止，也是一个递归操作
const getParentName: any = (pid: number, list: any) => {
  let obj: any = null
  obj = list.find((item: any) => item.id === pid)
  if (obj && obj.parentId !== 0) return getParentName(obj.parentId, list)
  return obj
}
const formatLbu = () => {
  const result = []
  const list = dataForm.value.saleChanceName?.split(',')
  if (list && list.length) {
    const [originCountry, country, channel] = list
    const originCountryName = areaStore.area.find((item) => item.id === originCountry)?.name;
    result.push(originCountryName || originCountry)
    const countryName = paramCodeData.value.lbu_demand_country?.find(
      (item: ParamCodeItem) => item.id === parseInt(country)
    )
    const flatList = flatTreeAndSetLevel(paramCodeData.value.lbu_products)
    const channelName = getParentName(parseInt(channel), flatList)
    result.push(countryName?.name || country)
    result.push(channelName?.name || channel)
    dataForm.value.saleChanceNameByTxt = result.join('+')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_step = _resolveComponent("a-step")!
  const _component_a_steps = _resolveComponent("a-steps")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_CosViewContent = _resolveComponent("CosViewContent")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_SellerButton = _resolveComponent("SellerButton")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_dc_penetrate_content = _resolveComponent("dc-penetrate-content")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_a_steps, { current: stepIndex.value }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stepsList.value, (item) => {
                  return (_openBlock(), _createBlock(_component_a_step, {
                    key: item.value,
                    status: item.chanceStatus === 6||item.chanceStatus === 8 ? 'process' : '',
                    title: item.label,
                    description: item.updateTime
                  }, null, 8, ["status", "title", "description"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["current"])
          ]),
          _createVNode(_component_CosViewContent, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_tabs, {
                activeKey: activeTabs.value,
                "onUpdate:activeKey": _cache[1] || (_cache[1] = ($event: any) => ((activeTabs).value = $event)),
                onChange: handleTabsChange
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_tab_pane, {
                    key: "info",
                    tab: "基本信息"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(DetailViewForm, {
                        ref_key: "businessFormRef",
                        ref: businessFormRef,
                        title: "基本信息",
                        type: "view",
                        value: dataForm.value,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataForm).value = $event)),
                        originalStatus: originalStatus.value
                      }, null, 8, ["value", "originalStatus"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, {
                    key: "record",
                    tab: "跟进记录"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(TabsClueCosFollowUp), {
                        permissionPage: permissionFollow,
                        appId: "cos_lbu",
                        chanceId: queryId.value
                      }, null, 8, ["chanceId"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, {
                    key: "logs",
                    tab: "操作日志"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(TabsOperationLog, {
                        appId: "cos_lbu",
                        tableId: "LbuBusinessOperationLog",
                        resourceId: queryId.value
                      }, null, 8, ["resourceId"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["activeKey"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_cos_footer_button, { hideOk: true }, {
        default: _withCtx(() => [
          (dataForm.value.status!=7)
            ? _withDirectives((_openBlock(), _createBlock(_component_SellerButton, {
                key: 0,
                controlType: "none",
                loading: loading.value,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (handleEdit()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("编辑")
                ]),
                _: 1
              }, 8, ["loading"])), [
                [_directive_permission, 'lbu_business_edit_btn']
              ])
            : _createCommentVNode("", true),
          _withDirectives((_openBlock(), _createBlock(_component_a_button, {
            loading: loading.value,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (handleWriteFollowUp()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("写跟进")
            ]),
            _: 1
          }, 8, ["loading"])), [
            [_directive_permission, 'lbu_business_write_follow_btn']
          ]),
          _createVNode(_component_a_popover, {
            placement: "topRight",
            trigger: "hover",
            color: "#132043e5"
          }, {
            content: _withCtx(() => [
              _createVNode(_component_dc_penetrate_content, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_a_radio_group, {
                      value: status.value,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((status).value = $event)),
                      style: {"width":"350px"},
                      disabled: loading.value,
                      onChange: statusChange
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(waitingChangeStepList.value, (item) => {
                          return (_openBlock(), _createBlock(_component_a_radio, {
                            key: item.value,
                            value: item.value,
                            disabled: item.disabled
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["value", "disabled"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value", "disabled"])
                  ])
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "primary",
                loading: loading.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode("状态变更")
                ]),
                _: 1
              }, 8, ["loading"])), [
                [_directive_permission, 'lbu_business_status_btn']
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})